import React, { useState } from "react";
import Navbar from "../navbar/navbar";
import { api } from "../../services/api";
import { Link, Navigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import "./produto.css";
import { vhostV1, vhostV2 } from "../funcoes";
import BuscaVazaia from "../components/buscavazia/buscaVazia";
import { NumericFormat } from "react-number-format";
import SweetAlert from "react-bootstrap-sweetalert";
import FooterBar from "../footer/footerBar";
import semImagem from "../../images/semImagem.jpg";
import axios from "axios";

function NovoProduto() {
  const inputs = document.querySelectorAll("input, select");

  // Adicione um manipulador de eventos para o evento "keydown" em cada entrada ou select
  inputs.forEach((input) => {
    input.addEventListener("keydown", (e) => {
      // Se a tecla pressionada for Enter
      if (e.key === "Enter") {
        e.preventDefault(); // evita que a tecla "Enter" envie um formulário, se aplicável

        // Obtenha o índice do elemento atual
        const currentIndex = Array.from(inputs).indexOf(e.target);

        // Mova o foco para o próximo elemento de entrada ou select
        const nextIndex = currentIndex + 1;
        if (nextIndex < inputs.length) {
          inputs[nextIndex].focus();
        }
      }
    });
  });

  const { cod } = useParams();
  const { tag } = useParams();

  const [cod_produto, setCod_produto] = useState("");
  const [descricao, setDescricao] = useState("");
  const [cod_grupo, setCod_grupo] = useState(0);
  const [unidade, setUnidade] = useState("");
  const [venda, setVenda] = useState(0);
  const [vendaDefault, setvendaDefault] = useState(0);
  const [ncm, setNcm] = useState("");
  const [sucesso, setSucesso] = useState("N");
  const [mensagem, setMensagem] = useState("");
  const [grupos, setGrupos] = useState([]);
  const [subGrupos, setSubGrupos] = useState([]);
  const [Linhas, setLinhas] = useState([]);
  const [cod_subgrupo, setCod_subGrupo] = useState(0);
  const [cod_linha, setCod_linha] = useState(0);
  const [compra, setCompra] = useState(0);
  const [compraDefault, setCompraDefault] = useState(0);
  const [st, setST] = useState("");
  const [icms_in, setIcms_in] = useState(0);
  const [icms_out, setIcms_out] = useState(0);
  const [cfop_in, setCfop_in] = useState("");
  const [cfop_out, setCfop_out] = useState("");
  const [cest, setCest] = useState("");
  const [cstpc, setCstpc] = useState("");
  const [cstpcEntrada, setCstpcEntrada] = useState(0);
  const [pisCredito, setPisCredito] = useState(0);
  const [cofinsCredito, setCofinsCredito] = useState(0);
  const [pisDebito, setpisDebito] = useState(0);
  const [cofinsDebito, setCofinsDebito] = useState(0);
  const [natReceita, setNatReceita] = useState("");
  const [cclass_trib, setCclass_trib] = useState("");
  const [redCbs, setRedCbs] = useState(0);
  const [redIbs, setRedIbs] = useState(0);
  const [indMonofasico, setIndMonofasico] = useState("0");
  const [seqNcm, setSeqNcm] = useState("");
  const [tipoProd, setTipoProd] = useState("0");
  const [sabores, setSabores] = useState(0);
  const [estoque, setEstoque] = useState(0);
  const [adicionais, setAdicionais] = useState(0);
  const [markup, setMarkup] = useState(0);
  const [markupDefault, setMarkupDefalt] = useState(0);
  const [vendaMarkup, setVendaMarkup] = useState(0);
  const [localizacao, setLocalizacao] = useState("");
  const [erroValidacao, setErrovalidacao] = useState(false);
  const [msgErro, setmsgErro] = useState("");
  const [resultImagem, setResultImagem] = useState(0);
  const [imagemProduto, setImagemProduto] = useState(semImagem);
  const [id, setId] = useState(-1);
  const [colaboradorAlteracao, setColaboradorAlteracao] = useState(0);
  const [colaboradorCad, setColaboradorCad] = useState(0);
  const [dataAlt, setDataAlt] = useState("");
  const [dataCad, setDataCad] = useState("");
  const [dataUltVenda, setDataUltVenda] = useState("");
  const [dataUltCompra, setDataUltCompra] = useState("");
  const [deflator, setDeflator] = useState(0);
  const [idCatalogo, setIdCatalogo] = useState(0);
  const [precoApp, setPrecoApp] = useState(0);
  const [vendaEditavel, setVendaEditavel] = useState(false);
  

  const [buscaNcm, setBuscaNcm] = useState("");
  const [Ncms, setNcms] = useState([]);
  const [sResult, setSresult] = useState(0);
  const [verificaProd, setVerificaProd] = useState("1");
  const [mostrarModalNcm, setMostrarModalNcm] = useState(false);
  const [buscaPorEan, setBuscaPorEan] = useState(false);


  const [imagemBase64, setImagemBase64] = useState("");
  const [isModalOpenImage, setIsModalOpenImage] = useState(false);
  const [activeTab, setActiveTab] = useState("valores");
  const [unidades, setUnidades] = useState([]);
  const [empresa, setEmpresa] = useState('');

  const [compostos, setCompostos] = useState([]);
 const [showModal, setShowModal] = useState(false);
const [produtos, setProdutos] = useState([]);
const [busca, setBusca] = useState("");
const [grupoIdCat, setGrupoIdCat] = useState(0);
const [unidadeIdCat, setUnidadeIdCat] = useState(0);
const [buscaCtWeb, setBuscaCtWeb] = useState("");
const [produtosCatalogo, setProdutosCatalogo] = useState([]);
  let config = {
    headers: {
      Authorization: localStorage.getItem("token"),
      "Content-Type": "application/json",
    },
    timeout: 10000,
  };

  let config2 = {
    headers: {
      Authorization: localStorage.getItem("token2"),
      "Content-Type": "application/json",
    },
    timeout: 10000,
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

   useEffect(function(){
          
                api.post(vhostV1('webcash/Empresa/retornaEmpresa'),{},config)
                  .then(function (response) {           
                    console.log(response);
                    setEmpresa(response.data.dados.CGC);
                    
                    
                                                
                             
                  })
                  .catch(function (error) {
                   
                    console.log(error);
          
                            
                  });
            
                  
                },[])

  function truncarComReticencias(texto, limite) {
          if (!texto) return '';
          return texto.length > limite
         ? texto.substring(0, limite - 3) + '...'
         : texto;
         }

  function formatDateToDDMMYYYY(isoDateString) {
    const date = new Date(isoDateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Janeiro é 0
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  useEffect(function(){
    api.post(vhostV1("webcash/unidades/listar"),{
            busca: "",
            pagina: 1,
            regPag: 100
        },config)
    .then(function(response){
      console.log(response);
      setUnidades(response.data.dados);
      

    }).catch(function(error){
      console.log(error);
    })
  },[])

  //buscar Grupos
  useEffect(function () {
    api
      .post(
        vhostV1("webcash/grupos"),
        {
          loja: 11,
          empresa: 0,
          busca: "",
          pagina: 1,
          regPag: 100
        },
        config
      )
      .then(function (response) {
        console.log(response);
        
        setGrupos(response.data.dados);
      })
      .catch(function (error) {
        console.log(error + "erro ao listar Grupos");
      });
  }, []);

  useEffect(function(){
             
                api.post(vhostV1('webcash/subgrupos'),{
                    pagina: 1,
                    regPag: 100,
                    busca: "",
                    cod_grupo: Number(cod_grupo) 
                  },config)
                  .then(function (response) {
  
                    setSubGrupos(response.data.dados);
                    console.log(response); 
                                                
                             
                  })
                  .catch(function (error) {
                   
                    console.log(error);
          
                            
                  });
                     
                  
              },[cod_grupo])

              useEffect(function(){
                   
                      api.post(vhostV1('webcash/linhaProd'), {
                          pagina: 1,
                          regPag: 100,
                          busca: "",
                          cod_subgrupo: Number(cod_subgrupo)
                        },config)
                        .then(function (response) {
                     
                          
                          setLinhas(response.data.dados);
                          console.log(response); 
                                                      
                                   
                        })
                        .catch(function (error) {
                         
                          console.log(error);
                
                                  
                        });
                           
                        
                    },[cod_subgrupo])
  

  function buscaIten() {
    api
      .post(
        vhostV1("webcash/produto/pesquisa/"+cod_produto),
        {
          loja: localStorage.getItem("loja"),
          empresa: 0,
        },
        config
      )
      .then(function (response) {
        if (response && response.data && response.data.dados) {
          setVerificaProd(response.data.dados[0].COD_PRODUTO);
          setId(response.data.dados[0].ID)
           setColaboradorCad(response.data.dados[0].COD_COLABORADORCADASTRO);
          setDataAlt(response.data.dados[0].DATA_ALTERACAO);
          setDataCad(response.data.dados[0].DATA_CADASTRO);
          setDataUltCompra(response.data.dados[0].DATA_ULT_COMPRA);
          setDataUltVenda(response.data.dados[0].DATA_ULT_VENDA);          
          setDescricao(response.data.dados[0].DESCRICAO);
          setNcm(response.data.dados[0].COD_NCM);
          setVenda(response.data.dados[0].VENDA);
          setVendaMarkup(response.data.dados[0].VENDA_MARKUP);
          setMarkup(response.data.dados[0].MARKUP);
          setMarkupDefalt(response.data.dados[0].MARKUP);
          setvendaDefault(response.data.dados[0].VENDA);
          setUnidade(response.data.dados[0].UNIDADE);
          setCod_grupo(response.data.dados[0].COD_GRUPO);
          setCompra(Number(response.data.dados[0].COMPRA));
          setCompraDefault(response.data.dados[0].COMPRA);
          setST(response.data.dados[0].ST);
          setCest(response.data.dados[0].CEST);
          setIcms_in(response.data.dados[0].ICMS_IN);
          setIcms_out(response.data.dados[0].ICMS_OUT);
          setCfop_in(response.data.dados[0].CFOP_IN);
          setCfop_out(response.data.dados[0].CFOP_OUT);
          setCstpc(response.data.dados[0].CSTPC);
          setCstpcEntrada(response.data.dados[0].CSTPC_ENTRADA);
          setPisCredito(Number(response.data.dados[0].ALI_PIS_CREDITO));
          setpisDebito(Number(response.data.dados[0].ALI_PIS_DEBITO));
          setCofinsCredito(Number(response.data.dados[0].ALI_COFINS_CREDITO));
          setCofinsDebito(Number(response.data.dados[0].ALI_COFINS_DEBITO));
          setNatReceita(response.data.dados[0].COD_RECEITA_PIS);
          setEstoque(response.data.dados[0].ESTOQUE);
          setLocalizacao(response.data.dados[0].LOCALIZACAO);
          setTipoProd(response.data.dados[0].TIPO_PROD);
          console.log(response);
        } else {
          buscaEan();
          console.log("não busquei");
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  function filtraProdutos(){
    
  const sJson = {}
  sJson.loja=localStorage.getItem('loja'); 
  sJson.empresa=0;
  sJson.grupo=0;
  sJson.subgrupo=0;
  sJson.linha=0;
  sJson.estoque_diferente=false;
  sJson.estoque_negativo=false;
  sJson.preco_zerado=false;
  sJson.inativo=false;
  sJson.pagina= 1;
  sJson.regPag=10;
  sJson.busca= busca; 
  sJson.tipoBusca=0; 
  sJson.tipo_prod=''; 
 
    api.post(vhostV1('webcash/produto/listar'),sJson,config)
      .then(function (response) {
          if(response && response.data && response.data.dados ){
            console.log(response.data.dados)
            setProdutos(response.data.dados);  
          }else{ 
          setProdutos([]);  
      }
                                    
      })
      .catch(function (error) {
        console.log(error);                  
      });
        
} 

useEffect(() => {
  if(tipoProd === "1"){
    setVendaEditavel(true)
    const soma = compostos.reduce((acc, item) => {
      return acc + (Number(item.PRECO) * Number(item.QTD));
    }, 0);

    setvendaDefault(soma);
    setVenda(soma);
  }else{
    setVendaEditavel(false);
  }
    
  }, [compostos, tipoProd]);

  //  useEffect(() => {
  //   const loja = localStorage.getItem("loja");

  //   api
  //     .get(vhostV2(`webcash/produto/retornafoto/${loja}/${cod_produto}`), config2)
  //     .then((response) => {
  //       if (response.data.result === 0) {
  //         setImagemProduto(semImagem);
  //       } else {
  //         const foto64 = response.data.dados.foto64;
  //         if (foto64) {

  //           const base64Src = `data:image/png;base64,${foto64}`;
  //           setImagemProduto(base64Src);
  //         } else {
  //           setImagemProduto(semImagem);
  //         }
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Erro na imagem do produto:", error);
  //       setImagemProduto(semImagem);
  //     });
  // }, [cod_produto]);

  console.log(cod);

 

  //buscar Produto
  useEffect(function(){
    
    api.post(vhostV1("webcash/produto/pesquisa/"+String(cod)),
        {
          loja: localStorage.getItem("loja"),
          empresa: 0,
        },
        config
      )
      .then(function (response) {
        console.log(response);

        if (response.data.result === 1) {
          if (response.data.imagem !== null) {
            setImagemProduto(response.data.imagem);
          }
          if(Number(tag) !== 3){
          setId(response.data.dados[0].ID);  
          setCod_produto(response.data.dados[0].COD_PRODUTO);
          setColaboradorCad(response.data.dados[0].COD_COLABORADORCADASTRO);
          setDataAlt(response.data.dados[0].DATA_ALTERACAO);
          setDataCad(response.data.dados[0].DATA_CADASTRO);
          setDataUltCompra(response.data.dados[0].DATA_ULT_COMPRA);
          setDataUltVenda(response.data.dados[0].DATA_ULT_VENDA);
          setEstoque(response.data.dados[0].ESTOQUE); 
          setCompra(Number(response.data.dados[0].COMPRA));
          setCompraDefault(response.data.dados[0].COMPRA);
          setColaboradorAlteracao(
            response.data.dados[0].COD_COLABORADORALTERACAO
          ); 
          }
          

          
        
          setDescricao(response.data.dados[0].DESCRICAO);
          setNcm(response.data.dados[0].COD_NCM);
          setVenda(response.data.dados[0].VENDA);
          setVendaMarkup(response.data.dados[0].VENDA_MARKUP);
          setMarkup(response.data.dados[0].MARKUP);
          setMarkupDefalt(response.data.dados[0].MARKUP);
          setvendaDefault(response.data.dados[0].VENDA);
          setUnidade(response.data.dados[0].UNIDADE);
          setCod_grupo(response.data.dados[0].COD_GRUPO);
          setCod_subGrupo(response.data.dados[0].COD_SUBGRUPO);
          setCod_linha(response.data.dados[0].COD_LINHA);
          setCompostos(response.data.dados[0].COMPOSTO);
          setST(response.data.dados[0].ST);
          setCest(response.data.dados[0].CEST);
          setIcms_in(response.data.dados[0].ICMS_IN);
          setIcms_out(response.data.dados[0].ICMS_OUT);
          setCfop_in(response.data.dados[0].CFOP_IN);
          setCfop_out(response.data.dados[0].CFOP_OUT);
          setCstpc(response.data.dados[0].CSTPC);
          setCstpcEntrada(response.data.dados[0].CSTPC_ENTRADA);
          setPisCredito(Number(response.data.dados[0].ALI_PIS_CREDITO));
          setpisDebito(Number(response.data.dados[0].ALI_PIS_DEBITO));
          setCofinsCredito(Number(response.data.dados[0].ALI_COFINS_CREDITO));
          setCofinsDebito(Number(response.data.dados[0].ALI_COFINS_DEBITO));
          setNatReceita(response.data.dados[0].COD_RECEITA_PIS);

          setGrupoIdCat(response.data.dados[0].GRUPO_CAT);
          setUnidadeIdCat(response.data.dados[0].UNIDADE_IDCAT);
          
          setLocalizacao(response.data.dados[0].LOCALIZACAO);
          setTipoProd(response.data.dados[0].TIPO_PROD);
          setCclass_trib(response.data.dados[0].CCLASS_TRIB);
          if(response.data.dados[0].RED_CBS !== null){
            setRedCbs(response.data.dados[0].RED_CBS);
          }
          
          setRedIbs(response.data.dados[0].RED_IBS);
          if(response.data.dados[0].IND_MONOFASICO !== null){
            setIndMonofasico(response.data.dados[0].IND_MONOFASICO);
          }
          setPrecoApp(response.data.dados[0].PRECO_APP);
          setIdCatalogo(response.data.dados[0].IDCATALOGO);
          setDeflator(response.data.dados[0].DEFLATOR);
        }
      });
  },[]);

  function buscaEan() {
  axios.get("https://app.sriservicos.com/SRiIntegradorISAPI.dll/api/v1/produtopadrao/"+cod_produto)
    .then(function(response) {
      console.log(response);
      if(response.data.data && response.data.data.DESCRICAO){
        setDescricao(response.data.data.DESCRICAO);
        setBuscaNcm(response.data.data.COD_NCM);
        setBuscaPorEan(true);
       
        
      }else{
        console.log("Produto não encontrado");
        
      }

    })
    .catch(function(error) {
      console.log(error);
    });
}

useEffect(function () {

  const body = buscaCtWeb
    ? { produto_id: Number(buscaCtWeb) }
    : {};

  api.post(
    vhostV1("webcash/mpm/listarProdutos"),
    body,
    config
  )
  .then(res => {
    console.log(res);
    setProdutosCatalogo(res.data.dados.data);
  })
  .catch(err => console.error(err));

}, [buscaCtWeb]);

useEffect(() => {
  if (buscaPorEan && buscaNcm) {
    listaNcm(new Event('submit'));
  }
}, [buscaNcm, buscaPorEan]);

  function listaNcm(e) {
    e.preventDefault();
    api
      .post(
        vhostV1("webcash/produto/pesquisar-ncm"),
        {
          loja: localStorage.getItem("loja"),
          empresa: 0,
          busca: buscaNcm,
        },
        config
      )
      .then(function (response) {
        console.log(response);
        if(buscaPorEan === true && response.data.dados.length === 1){
          pesquisaNcm(response.data.dados[0].SEQ);
        }else if(buscaPorEan === true && response.data.dados.length > 1){
          setSresult(response.data.result);
          setNcms(response.data.dados);
          setMostrarModalNcm(true);
        }else{
          setSresult(response.data.result);
          setNcms(response.data.dados);
        }

        

        
        
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  function pesquisaNcm(e) {
    api
      .post(
        vhostV1("webcash/produto/ncm"),
        {
          loja: localStorage.getItem("loja"),
          empresa: 0,
          seq: e,
        },
        config
      )
      .then(function (response) {
        console.log(response);
        setNcm(response.data.dados.NCM);
        setST(response.data.dados.ST);
        setIcms_in(response.data.dados.ICMS_IN);
        setIcms_out(response.data.dados.ICMS_OUT);
        setCfop_in(response.data.dados.CFOP_IN);
        setCfop_out(response.data.dados.CFOP_OUT);
        setCest(response.data.dados.CEST);
        setCstpc(response.data.dados.CSTPC);
        setCstpcEntrada(response.data.dados.CSTPC_ENTRADA);
        setPisCredito(response.data.dados.PERCPISCRED);
        setCofinsCredito(response.data.dados.PERCCOFINSCRED);
        setpisDebito(response.data.dados.PERCPISCRED);
        setCofinsDebito(response.data.dados.PERCCOFINSCRED);
        setNatReceita(response.data.dados.NAT_RECEITA);
        setCclass_trib(response.data.dados.CCLASS_TRIB);
        setRedCbs(response.data.dados.RED_CBS);
        setRedIbs(response.data.dados.RED_IBS);
        if(response.data.dados.IND_MONOFASICO === null) {
          setIndMonofasico("0");
        } else {
        setIndMonofasico(response.data.dados.IND_MONOFASICO);
      }
      });
  }

  function calculaVenda() {
    let mk = (compra * markup) / 100;
    let vendaSugerida = Number(compra) + Number(mk);
    setVendaMarkup(vendaSugerida);
  }

  // useEffect(function(){
  //   if(cod_produto === verificaProd){
  //     {setmsgErro('CÓDIGO DE PRODUTO JÁ CADASTRADO');
  //     setErrovalidacao(true)}
  //     return
  //   }
  // },[verificaProd])

  const sJson = {
            loja: Number(localStorage.getItem("loja")),
            EMPRESA: 0,
            COD_INTERNO: Number(id),
            COD_PRODUTO: cod_produto,
            DESCRICAO: descricao,
            COD_GRUPO: Number(cod_grupo),
            UNIDADE: unidade,
            ESTOQUE: estoque,
            MARKUP: Number(markup),
            VENDA_MARKUP: Number(vendaMarkup),
            VENDA: Number(venda),
            COMPRA: Number(compra),
            COD_COLABORADORCADASTRO: Number(localStorage.getItem("colaborador")),
            COD_NCM: ncm,
            ST: st,
            ICMS_IN: Number(icms_in),
            ICMS_OUT: Number(icms_out),
            CFOP_IN: cfop_in,
            CFOP_OUT: cfop_out,
            CEST: cest,
            CSTPC: Number(cstpc),
            CSTPC_ENTRADA: Number(cstpcEntrada),
            ALI_COFINS_CREDITO: Number(cofinsCredito),
            ALI_COFINS_DEBITO: Number(cofinsDebito),
            ALI_PIS_CREDITO: Number(pisCredito),
            ALI_PIS_DEBITO: Number(pisDebito),
            SABORES: sabores,
            ADICIONAIS: adicionais,
            LOCALIZACAO: localizacao,
            QTD_EMBALAGEM: 1,
            TIPO_VENDA: tipoProd,
            COD_RECEITA_PIS: natReceita,
            CCLASS_TRIB: cclass_trib,
            RED_CBS: Number(redCbs),
            RED_IBS: Number(redIbs),
            IND_MONOFASICO: String(indMonofasico),
            IDCATALOGO: Number(idCatalogo),
            PRECO_APP: Number(precoApp),
            DEFLATOR: Number(deflator),
            imagem: imagemBase64,  
            cnpj_imagem: empresa,
            COD_SUBGRUPO: Number(cod_subgrupo),
            COD_LINHA: Number(cod_linha),
            GRUPO_IDCAT: Number(grupoIdCat),
            UNIDADE_IDCAT: Number(unidadeIdCat),
            COMPOSTO: compostos
          };

  console.log(sJson);

  function salvaProduto(e) {
    e.preventDefault();
    if (cod_produto.length === 0) {
      {
        setmsgErro("CÓDIGO DO PRODUTO NÃO PODE ESTAR VAZIO");
        setErrovalidacao(true);
      }
      return;
    } else if (descricao.length === 0) {
      {
        setmsgErro("DESCRIÇÃO DO PRODUTO NÃO PODE ESTAR VAZIO");
        setErrovalidacao(true);
      }
      return;
    } else if (Number(cod_grupo) === 0) {
      {
        setmsgErro("SELECIONE UM GRUPO PARA O PRODUTO");
        setErrovalidacao(true);
      }
      return;
    } else if (unidade === "") {
      {
        setmsgErro("SELECIONE UMA UNIDADE PARA O PRODUTO");
        setErrovalidacao(true);
      }
      return;
    }else if (descricao.length > 60) {
      {
        setmsgErro("DESCRIÇÃO DO PRODUTO NÃO PODE PASSAR 60 CARACTERES");
        setErrovalidacao(true);
      }
      return;
    } else if (ncm.length === 0) {
      {
        setmsgErro("NCM NÃO PODE ESTAR VAZIO");
        setErrovalidacao(true);
      }
      return;
    } else if (venda.length === 0 || Number(venda) === 0) {
      
        setmsgErro("VALOR DE VENDA NÃO PODE ESTAR VAZIO/ZERADO");
        setErrovalidacao(true);
      
      return;
    } else if(tipoProd === "1" && compostos.length === 0){
      setmsgErro("PRODUTO COMPOSTO DEVE CONTER AO MENOS UM ITEM");
      setErrovalidacao(true);
      return;
    }
   
    else {
      api
        .post(
          vhostV1("webcash/produto/cadastro"),
          {
            loja: Number(localStorage.getItem("loja")),
            EMPRESA: 0,
            COD_INTERNO: Number(id),
            COD_PRODUTO: cod_produto,
            DESCRICAO: descricao,
            COD_GRUPO: Number(cod_grupo),
            UNIDADE: unidade,
            ESTOQUE: estoque,
            MARKUP: Number(markup),
            VENDA_MARKUP: Number(vendaMarkup),
            VENDA: Number(venda),
            COMPRA: Number(compra),
            COD_COLABORADORCADASTRO: Number(localStorage.getItem("colaborador")),
            COD_NCM: ncm,
            ST: st,
            ICMS_IN: Number(icms_in),
            ICMS_OUT: Number(icms_out),
            CFOP_IN: cfop_in,
            CFOP_OUT: cfop_out,
            CEST: cest,
            CSTPC: Number(cstpc),
            CSTPC_ENTRADA: Number(cstpcEntrada),
            ALI_COFINS_CREDITO: Number(cofinsCredito),
            ALI_COFINS_DEBITO: Number(cofinsDebito),
            ALI_PIS_CREDITO: Number(pisCredito),
            ALI_PIS_DEBITO: Number(pisDebito),
            SABORES: sabores,
            ADICIONAIS: adicionais,
            LOCALIZACAO: localizacao,
            QTD_EMBALAGEM: 1,
            TIPO_VENDA: tipoProd,
            COD_RECEITA_PIS: natReceita,
            CCLASS_TRIB: cclass_trib,
            RED_CBS: Number(redCbs),
            RED_IBS: Number(redIbs),
            IND_MONOFASICO: String(indMonofasico),
            IDCATALOGO: Number(idCatalogo),
            PRECO_APP: Number(precoApp),
            DEFLATOR: Number(deflator),
            imagem: imagemBase64,  
            cnpj_imagem: empresa,
            COD_SUBGRUPO: Number(cod_subgrupo),
            COD_LINHA: Number(cod_linha),
            GRUPO_IDCAT: Number(grupoIdCat),
            UNIDADE_IDCAT: Number(unidadeIdCat),
            COMPOSTO: compostos
          },
          config
        )
        .then(function (response) {
          console.log(response);

          if (response.data.result === 1) {
            setMensagem("");
            setSucesso("S");
          } else {
            console.log(response);
            setSucesso("N");
          }
        })
        .catch((erro) => {
          setMensagem(erro);
          setSucesso("N");
          console.log(erro);
        });
    }
  }

  const handleGrupoChange = (e) => {
  const codigoGrupo = e.target.value;

  setCod_grupo(codigoGrupo);

  const grupoSelecionado = grupos.find(
    (grupo) => String(grupo.COD_GRUPO) === String(codigoGrupo)
  );

  if (grupoSelecionado) {
    setGrupoIdCat(grupoSelecionado.CAT_WEB);
  } else {
    setGrupoIdCat(0);
  }
};

const handleUnidadeChange = (e) => {
  const codigoUnidade = e.target.value;

  setUnidade(codigoUnidade);

  const unidadeSelecionada = unidades.find(
    (un) => String(un.COD) === String(codigoUnidade)
  );

  if (unidadeSelecionada) {
    setUnidadeIdCat(unidadeSelecionada.ID_CATALOGO);
  } else {
    setUnidadeIdCat(0);
  }
};

  return (
    <div className="conteiner-fluid titulo ">
      <Navbar />
      <div className="offset-lg-1 col-lg-10">
        <h2>Cadastro de Produto</h2>
        <hr />
        <div className="conteiner-fluid">
          <form id="table-servico" className="row tela">
            <div className="row align-items-center mb-3">
              <div className="col-2">
                <label htmlFor="inputCodigo" className="form-label">
                  CÓDIGO
                </label>
                
                  <input
                  type="text"
                  value={cod_produto}
                  onChange={(e) => setCod_produto(e.target.value)}
                  onBlur={buscaIten}
                  className="form-control"
                  id="inputCodigo"
                  tabIndex="1"
                  required
                  autoComplete="off"
                />
               
                
              </div>

              <div className="col-8">
                <label htmlFor="inputDescricao" className="form-label">
                  DESCRIÇÃO
                </label>
                <input
                  type="text"
                  value={descricao}
                  onChange={(e) => setDescricao(e.target.value)}
                  className="form-control"
                  id="inputDescricao"
                  tabIndex="2"
                  required
                  autoComplete="off"
                />
              </div>
            <div className="col-2 text-center">
  <div className="mt-2">

    {/* Input escondido para selecionar a imagem */}
    <input
      type="file"
      accept="image/*"
      style={{ display: "none" }}
      id="inputImagemProduto"
      onChange={(e) => {
        const file = e.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onloadend = () => {
            const base64 = reader.result.split(",")[1]; 
            setImagemProduto(`data:${file.type};base64,${base64}`); 
            setImagemBase64(base64); 
          };
          reader.readAsDataURL(file);
        }
      }}
    />

    {/* Imagem clicável para expandir */}
   <div className="d-flex flex-column align-items-center">
  <img
    src={imagemProduto}
    alt="Imagem do Produto"
    className="img-thumbnail"
    style={{
      maxWidth: "100px",
      height: "100px",
      cursor: "pointer",
    }}
    onClick={() => setIsModalOpenImage(true)} // mantém a lógica antiga
  />

  {/* Botão para selecionar a imagem */}
  <button
    type="button"
    className="btn btn-sm btn-primary mt-2"
    onClick={() => document.getElementById("inputImagemProduto").click()}
  >
    Adicionar Imagem
  </button>
</div>
  </div>
</div>
            </div>

            {isModalOpenImage && (
              <div
                className="modal fade show d-block"
                tabIndex="-1"
                onClick={() => setIsModalOpenImage(false)}
                style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
              >
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-body p-0">
                      <img
                        src={imagemProduto}
                        alt="Imagem Expandida"
                        className="img-fluid"
                        style={{ width: "100%" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="col-md-2"> <label htmlFor="inputState" className="form-label"> GRUPO </label> 
           <select
  id="inputGrupo"
  value={cod_grupo}
  onChange={handleGrupoChange}
  className="form-select"
  tabIndex="3"
>
  <option value={0}>SELECIONE</option>
  {grupos.map((grupo) => {
    return (
      <option key={grupo.COD_GRUPO} value={grupo.COD_GRUPO}>
        {grupo.COD_GRUPO} - {grupo.DESCRICAO}
      </option>
    );
  })}
</select>
            </div>

            <div className="col-md-2">
  <label htmlFor="inputState" className="form-label">
    SUB-GRUPO
  </label>
  <select
    id="inputGrupo"
    value={cod_subgrupo}
    onChange={(e) => {
      const selected = subGrupos.find(
        (grupo) => grupo.COD_SUBGRUPO == e.target.value
      );

      setCod_subGrupo(e.target.value);

      if (selected) {
        setMarkup(selected.MARKUP);
        setMarkupDefalt(selected.MARKUP);
      }
    }}
    className="form-select"
    tabIndex="3"
  >
    <option value={0}>SELECIONE</option>
    {subGrupos.map((grupo) => {
      return (
        <option key={grupo.COD_SUBGRUPO} value={grupo.COD_SUBGRUPO}>
          {grupo.COD_SUBGRUPO} - {grupo.DESCRICAO}
        </option>
      );
    })}
  </select>
</div>

            <div className="col-md-2">
              <label htmlFor="inputState" className="form-label">
                LINHA
              </label>
              <select
                id="inputGrupo"
                value={cod_linha}
                onChange={(e) => setCod_linha(e.target.value)}
                className="form-select"
                tabIndex="3"
              >
                <option value={0}>SELECIONE</option>
                {Linhas.map((grupo) => {
                  return (
                    <option key={grupo.COD_LINHA} value={grupo.COD_LINHA}>
                      {grupo.COD_LINHA} - {grupo.DESCRICAO}
                    </option>
                  );
                })}
              </select>
            </div>

            <div className="col-md-2">
  <label htmlFor="inputState" className="form-label">
    UNIDADE
  </label>
  <select
    id="inputUnidade"
    value={unidade}
    onChange={handleUnidadeChange}
    className="form-select"
    tabIndex="4"
  >
  <option value={""}>SELECIONE</option>
    {unidades.map((un) => {
      return (
        <option key={un.COD} value={un.COD}>
          {un.COD} - {un.DESCRICAO}
        </option>
      );
    })}
  </select>
</div>

            <div className="col-md-2">
              <label htmlFor="inputCity" className="form-label">
                NCM
              </label>
              <div className="input-group mb-3">
                <input
                  type="text"
                  value={ncm}
                  onChange={(e) => setNcm(e.target.value)}
                  className="form-control"
                  id="inputNcm"
                  tabIndex="5"
                  readOnly
                  required
                />
                {tag != 0 ? (
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setMostrarModalNcm(true)}
                  >
                    pesquisar
                  </button>
                ) : null}
              </div>


           {mostrarModalNcm && (
  <div
    className="modal fade show d-block mt-5"
    tabIndex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-modal="true"
    role="dialog"
  >
    <div className="modal-dialog modal-lg">
      <div className="modal-content">
        <div className="modal-header">
          <h1 className="modal-title fs-5" id="staticBackdropLabel">
            Pesquisa NCM
          </h1>
          <button
            type="button"
            className="btn-close"
            onClick={() => setMostrarModalNcm(false)}
            aria-label="Close"
          ></button>
        </div>
        <div className="modal-body">
          <div>
            <div className="input-group mb-3">
              <input
                onChange={(e) => setBuscaNcm(e.target.value)}
                type="text"
                className="form-control"
                placeholder="Digite sua pesquisa"
                aria-describedby="button-addon2"
              />
              <button
                onClick={listaNcm}
                className="btn btn-primary"
                type="button"
                id="button-addon2"
              >
                <i className="fas fa-search"></i> Pesquisar
              </button>
            </div>

            {sResult === true ? (
              <table
                id="table-produto"
                className="table table-hover table-striped"
              >
                <thead>
                  <tr>
                    <th scope="col">Codigo</th>
                    <th scope="col">Descricao</th>
                    <th scope="col">CEST</th>
                    <th scope="col">ICMS</th>
                    <th scope="col">AÇÃO</th>
                  </tr>
                </thead>
                <tbody className="table-group-divider">
                  {Ncms.map((ncm) => (
                    <tr key={ncm.SEQ}>
                      <td>{ncm.NCM}</td>
                      <td>{truncarComReticencias(ncm.PRODUTO, 60)}</td>
                      <td>{ncm.CEST}</td>
                      <td>{Number(ncm.ICMS_IN).toFixed(2)}</td>
                      <td>
                        <a
                          href="#"
                          onClick={() => {
                            pesquisaNcm(ncm.SEQ);
                            setMostrarModalNcm(false);
                          }}
                        >
                          <i className="bi bi-check-lg"></i>
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <BuscaVazaia />
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
)}
            </div>

            <div className="col-md-1">
              <label htmlFor="inputState" className="form-label">
                TIPO PROD
              </label>
              <select
                id="inputUnidade"
                value={tipoProd}
                onChange={(e) => setTipoProd(e.target.value)}
                className="form-select"
                tabIndex="5"
              >
                <option value={"0"}>VENDA</option>
                <option value={"1"}>COMPOSTO</option>
                <option value={"2"}>CONSUMO</option>
                <option value={"3"}>MATERIA_PRIMA</option>
                <option value={"4"}>MIX</option>
                <option value={"5"}>CORTE</option>
              </select>
            </div>

            <div className="col-md-1">
              <label htmlFor="inputState" className="form-label">
                IMPRESSORA
              </label>
              <select
                id="inputUnidade"
                value={localizacao}
                onChange={(e) => setLocalizacao(e.target.value)}
                className="form-select"
                tabIndex="5"
              >
                <option value={0}>SELECIONE</option>
                <option value={1}>COZINHA</option>
                <option value={2}>PRODUCAO</option>
                <option value={3}>COZINHA2</option>
              </select>
            </div>

            <nav>
              <div className="nav nav-tabs mb-2" role="tablist">
                <button
                  className={`nav-link ${
                    activeTab === "valores" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("valores")}
                  type="button"
                  role="tab"
                >
                  Valores
                </button>
                <button
                  className={`nav-link ${
                    activeTab === "impostos" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("impostos")}
                  type="button"
                  role="tab"
                >
                  Impostos
                </button>
                <button
                  className={`nav-link ${activeTab === "mov" ? "active" : ""}`}
                  onClick={() => handleTabClick("mov")}
                  type="button"
                  role="tab"
                >
                  Movimentação
                </button>
                <button
                  className={`nav-link ${
                    activeTab === "ctWeb" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("ctWeb")}
                  type="button"
                  role="tab"
                >
                  Catálogo Web
                </button>
                {tipoProd === "1" && (
                  <button
                    className={`nav-link ${
                      activeTab === "Composto" ? "active" : ""
                    }`}
                    onClick={() => handleTabClick("Composto")}
                    type="button"
                    role="tab"
                  >
                    Composição
                  </button>
                )}
              </div>
            </nav>

            <div className="tab-content" id="nav-tabContent">
              <div
                className={`tab-pane fade ${
                  activeTab === "valores" ? "show active" : ""
                }`}
              >
                <div className="row">
                  <div className="col-2">
                    <label htmlFor="inputAddress" className="form-label">
                      ESTOQUE
                    </label>
                    <NumericFormat
                      className="form-control"
                      id="inputMarkup"
                      value={estoque.toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })}
                      tabIndex="7"
                      allowLeadingZeros
                      decimalSeparator=","
                      thousandSeparator="."
                      decimalScale={3}
                      readOnly={true}
                    />
                  </div>

                  <div className="col-2">
                    <label htmlFor="inputAddress" className="form-label">
                      MARKUP
                    </label>
                    <NumericFormat
                      className="form-control"
                      id="inputMarkup"
                      value={markupDefault.toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })}
                      tabIndex="7"
                      allowLeadingZeros
                      decimalSeparator=","
                      thousandSeparator="."
                      onBlur={calculaVenda}
                      decimalScale={2}
                      suffix=" %"
                      onValueChange={(values, suorceInfo) => {
                        setMarkup(values.value);
                      }}
                    />
                  </div>

                  <div className="col-2">
                    <label htmlFor="inputAddress" className="form-label">
                      COMPRA
                    </label>
                    <NumericFormat
                      className="form-control"
                      id="inputCompra"
                      value={compraDefault.toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })}
                      tabIndex="8"
                      allowLeadingZeros
                      decimalSeparator=","
                      thousandSeparator="."
                      onBlur={calculaVenda}
                      decimalScale={2}
                      prefix="R$ "
                      onValueChange={(values, suorceInfo) => {
                        setCompra(values.value);
                      }}
                    />
                  </div>

                  <div className="col-3">
                    <label htmlFor="inputAddress" className="form-label">
                      PREÇO SUGERIDO
                    </label>
                    <NumericFormat
                      className="form-control"
                      id="inputsugestao"
                      value={vendaMarkup.toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })}
                      tabIndex="50"
                      allowLeadingZeros
                      decimalSeparator=","
                      thousandSeparator="."
                      decimalScale={2}
                      prefix="R$ "
                    />
                  </div>

                  <div className="col-3">
                    <label htmlFor="inputAddress" className="form-label">
                      VALOR
                    </label>
                    <NumericFormat
                      className="form-control"
                      id="inputVenda"
                      value={vendaDefault.toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })}
                      tabIndex="9"
                      allowLeadingZeros
                      decimalSeparator=","
                      thousandSeparator="."
                      decimalScale={2}
                      required
                      prefix="R$ "
                      onValueChange={(values, suorceInfo) => {
                        setVenda(values.value);
                      }}
                      readOnly={vendaEditavel}
                    />
                  </div>
                </div>
              </div>
              <div
                className={`tab-pane fade ${
                  activeTab === "impostos" ? "show active" : ""
                }`}
              >
                <div className="row">
                  <div className="col-2">
                    <label htmlFor="inputAddress" className="form-label">
                      ST
                    </label>
                    <input
                      type="text"
                      value={st}
                      onChange={(e) => setST(e.target.value)}
                      className="form-control"
                      id="inputST"
                      tabIndex="7"
                      disabled
                    />
                  </div>

                  <div className="col-2">
                    <label htmlFor="inputAddress" className="form-label">
                      ICMS DENTRO
                    </label>
                    <input
                      type="text"
                      value={Number(icms_in).toFixed(2)}
                      onChange={(e) => setIcms_in(e.target.value)}
                      className="form-control"
                      id="inputICMSIN"
                      tabIndex="8"
                      disabled
                    />
                  </div>

                  <div className="col-2">
                    <label htmlFor="inputAddress" className="form-label">
                      ICMS FORA
                    </label>
                    <input
                      type="text"
                      value={Number(icms_out).toFixed(2)}
                      onChange={(e) => setIcms_out(e.target.value)}
                      className="form-control"
                      id="inputICMSOUT"
                      tabIndex="9"
                      disabled
                    />
                  </div>

                  <div className="col-2">
                    <label htmlFor="inputAddress" className="form-label">
                      CFOP DENTRO
                    </label>
                    <input
                      type="text"
                      value={cfop_in}
                      onChange={(e) => setCfop_in(e.target.value)}
                      className="form-control"
                      id="inputCFOPIN"
                      tabIndex="10"
                      disabled
                    />
                  </div>

                  <div className="col-2">
                    <label htmlFor="inputAddress" className="form-label">
                      CFOP FORA
                    </label>
                    <input
                      type="text"
                      value={cfop_out}
                      onChange={(e) => setCfop_out(e.target.value)}
                      className="form-control"
                      id="inputCFOPOUT"
                      tabIndex="11"
                      disabled
                    />
                  </div>

                  <div className="col-2">
                    <label htmlFor="inputAddress" className="form-label">
                      CEST
                    </label>
                    <input
                      type="text"
                      value={cest}
                      onChange={(e) => setCest(e.target.value)}
                      className="form-control"
                      id="inputCEST"
                      tabIndex="12"
                      disabled
                    />
                  </div>

                  <div className="col-3">
                    <label htmlFor="inputAddress" className="form-label">
                      CSTPC
                    </label>
                    <input
                      type="text"
                      value={cstpc}
                      onChange={(e) => setCstpc(e.target.value)}
                      className="form-control"
                      id="inputCEST"
                      tabIndex="12"
                      disabled
                    />
                  </div>

                  <div className="col-3">
                    <label htmlFor="inputAddress" className="form-label">
                      ALI. PIS DEBITO
                    </label>
                    <input
                      type="text"
                      value={pisDebito}
                      onChange={(e) => setpisDebito(e.target.value)}
                      className="form-control"
                      id="inputCEST"
                      tabIndex="12"
                      disabled
                    />
                  </div>

                  <div className="col-3">
                    <label htmlFor="inputAddress" className="form-label">
                      ALI. COFINS DEBITO
                    </label>
                    <input
                      type="text"
                      value={cofinsDebito}
                      onChange={(e) => setCofinsDebito(e.target.value)}
                      className="form-control"
                      id="inputCEST"
                      tabIndex="12"
                      disabled
                    />
                  </div>

                  <div className="col-3">
                    <label htmlFor="inputAddress" className="form-label">
                      NAT. RECEITA
                    </label>
                    <input
                      type="text"
                      value={natReceita}
                      onChange={(e) => setNatReceita(e.target.value)}
                      className="form-control"
                      id="inputCEST"
                      tabIndex="12"
                      disabled
                    />
                  </div>

                  <div className="col-3">
                    <label htmlFor="inputAddress" className="form-label">
                      CSTPC ENTRADA
                    </label>
                    <input
                      type="text"
                      value={cstpcEntrada}
                      onChange={(e) => setCstpcEntrada(e.target.value)}
                      className="form-control"
                      id="inputCEST"
                      tabIndex="12"
                      disabled
                    />
                  </div>

                  <div className="col-3">
                    <label htmlFor="inputAddress" className="form-label">
                      ALI. PIS CREDITO
                    </label>
                    <input
                      type="text"
                      value={pisCredito}
                      onChange={(e) => setPisCredito(e.target.value)}
                      className="form-control"
                      id="inputCEST"
                      tabIndex="12"
                      disabled
                    />
                  </div>

                  <div className="col-3">
                    <label htmlFor="inputAddress" className="form-label">
                      ALI. COFINS CREDITO
                    </label>
                    <input
                      type="text"
                      value={cofinsCredito}
                      onChange={(e) => setCofinsCredito(e.target.value)}
                      className="form-control"
                      id="inputCEST"
                      tabIndex="12"
                      disabled
                    />
                  </div>

                  <div className="col-3">
                    <label htmlFor="inputAddress" className="form-label">
                      CLASS. TRIB
                    </label>
                    <input
                      type="text"
                      value={cclass_trib}
                      onChange={(e) => setCclass_trib(e.target.value)}
                      className="form-control"
                      id="inputCEST"
                      tabIndex="12"
                      disabled
                    />
                  </div>

                  <div className="col-3">
                    <label htmlFor="inputAddress" className="form-label">
                      RED. IBS
                    </label>
                    <input
                      type="text"
                      value={redIbs}
                      onChange={(e) => setRedIbs(e.target.value)}
                      className="form-control"
                      id="inputCEST"
                      tabIndex="12"
                      disabled
                    />
                  </div>

                  <div className="col-3">
                    <label htmlFor="inputAddress" className="form-label">
                      RED. CBS
                    </label>
                    <input
                      type="text"
                      value={redCbs}
                      onChange={(e) => setRedCbs(e.target.value)}
                      className="form-control"
                      id="inputCEST"
                      tabIndex="12"
                      disabled
                    />
                  </div>

                  <div className="col-3">
                    <label htmlFor="inputAddress" className="form-label">
                     IND. MONOFASICO
                    </label>
                    <input
                      type="text"
                      value={indMonofasico}
                      onChange={(e) => setIndMonofasico(e.target.value)}
                      className="form-control"
                      id="inputCEST"
                      tabIndex="12"
                      disabled
                    />
                  </div>

                  {tipoProd === "4" ? (
                    <div className="row col-12 ">
                      <div className="col-md-3">
                        <label htmlFor="inputState" className="form-label">
                          VARIAÇÕES
                        </label>
                        <select
                          id="inputGrupo"
                          onChange={(e) =>
                            setSabores(e.target.value.substring(1, 3))
                          }
                          className="form-select"
                          tabIndex="4"
                        >
                          {grupos.map((grupo) => {
                            return (
                              <option key={grupo.cod_grupo}>
                                {" "}
                                {("000" + grupo.cod_grupo).slice(-3) +
                                  " - " +
                                  grupo.descricao}
                              </option>
                            );
                          })}
                        </select>
                      </div>

                      <div className="col-md-3">
                        <label htmlFor="inputState" className="form-label">
                          ADICIONAIS
                        </label>
                        <select
                          id="inputGrupo"
                          onChange={(e) =>
                            setAdicionais(e.target.value.substring(1, 3))
                          }
                          className="form-select"
                          tabIndex="4"
                        >
                          {grupos.map((grupo) => {
                            return (
                              <option key={grupo.cod_grupo}>
                                {" "}
                                {("000" + grupo.cod_grupo).slice(-3) +
                                  " - " +
                                  grupo.descricao}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>
                  ) : (
                    <div className="row"></div>
                  )}
                </div>
              </div>
              <div
                className={`tab-pane fade ${
                  activeTab === "mov" ? "show active" : ""
                }`}
              >
                <div className="row">
                  <div className="col-3">
                    <label htmlFor="inputAddress" className="form-label">
                      COD. COLABORADOR CADASTRO
                    </label>
                    <input
                      type="text"
                      value={colaboradorCad !== null ? colaboradorCad : 0}
                      className="form-control"
                      id="inputCEST"
                      tabIndex="12"
                      disabled
                    />
                  </div>
                  <div className="col-3">
                    <label htmlFor="inputAddress" className="form-label">
                      DATA CADASTRO
                    </label>
                    <input
                      type="text"
                      value={
                        dataCad !== null
                          ? formatDateToDDMMYYYY(dataCad)
                          : "Não há informações"
                      }
                      className="form-control"
                      id="inputCEST"
                      tabIndex="12"
                      disabled
                    />
                  </div>
                  <div className="col-3">
                    <label htmlFor="inputAddress" className="form-label">
                      COD. COLABORADOR ALTERAÇÃO
                    </label>
                    <input
                      type="text"
                      value={
                        colaboradorAlteracao !== null ? colaboradorAlteracao : 0
                      }
                      className="form-control"
                      id="inputCEST"
                      tabIndex="12"
                      disabled
                    />
                  </div>
                  <div className="col-3">
                    <label htmlFor="inputAddress" className="form-label">
                      DATA DE ALTERAÇÃO
                    </label>
                    <input
                      type="text"
                      value={
                        dataAlt !== null
                          ? formatDateToDDMMYYYY(dataAlt)
                          : "Não há informações"
                      }
                      className="form-control"
                      id="inputCEST"
                      tabIndex="12"
                      disabled
                    />
                  </div>
                  <div className="col-3">
                    <label htmlFor="inputAddress" className="form-label">
                      DATA ULTIMA COMPRA
                    </label>
                    <input
                      type="text"
                      value={
                        dataUltCompra !== null
                          ? formatDateToDDMMYYYY(dataUltCompra)
                          : "Não há informações"
                      }
                      className="form-control"
                      id="inputCEST"
                      tabIndex="12"
                      disabled
                    />
                  </div>
                  <div className="col-3">
                    <label htmlFor="inputAddress" className="form-label">
                      DATA ULTIMA VENDA
                    </label>
                    <input
                      type="text"
                      value={
                        dataUltVenda !== null
                          ? formatDateToDDMMYYYY(dataUltVenda)
                          : "Não há informações"
                      }
                      className="form-control"
                      id="inputCEST"
                      tabIndex="12"
                      disabled
                    />
                  </div>
                </div>
              </div>
              {/* <div className="tab-content" id="nav-tabContent"> */}
              <div
  className={`tab-pane fade ${
    activeTab === "Composto" ? "show active" : ""
  }`}
>
  <div className="mb-3">
    <button
    type="button"
  className="btn btn-primary mb-3"
  onClick={(e) => {
    e.preventDefault();
    setShowModal(true);
    filtraProdutos(); // já carrega inicial
  }}
>
  + Adicionar Produto
</button>
  </div>

  <table className="table table-bordered">
    <thead>
      <tr>
        <th>Código</th>
        <th>Descrição</th>
        <th>Preço</th>
        <th>Qtd</th>
        <th>Ações</th>
      </tr>
    </thead>

    <tbody>
      {compostos.map((item, index) => (
        <tr key={index}>
          <td>{item.BARRA}</td>

          <td>{item.DESCRICAO}</td>

          <td>
  <NumericFormat
    className="form-control"
    value={item.PRECO}
    decimalSeparator=","
    thousandSeparator="."
    decimalScale={2}
    fixedDecimalScale
    prefix="R$ "
    allowNegative={false}
    onValueChange={(values) => {
      const { floatValue } = values;

      const novos = [...compostos];
      novos[index].PRECO = floatValue || 0;
      setCompostos(novos);
    }}
  />
</td>

          <td>
            <input
              type="number"
              className="form-control"
              value={item.QTD}
              onChange={(e) => {
                const novos = [...compostos];
                novos[index].QTD = Number(e.target.value);
                setCompostos(novos);
              }}
            />
          </td>

          <td>
            <button
              className="btn btn-danger btn-sm"
              type="button"
              onClick={() => {
                const novos = compostos.filter((_, i) => i !== index);
                setCompostos(novos);
              }}
            >
              Remover
            </button>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>
              {/* </div> */}
              <div
                className={`tab-pane fade ${
                  activeTab === "ctWeb" ? "show active" : ""
                }`}
              >

                <div className="row">
                  <div className="col-md-2">
  <label htmlFor="inputIdCatalogo" className="form-label">
    ID CATÁLOGO
  </label>

  <div className="input-group">
    <input
      type="text"
      value={idCatalogo}
      className="form-control"
      id="inputIdCatalogo"
      disabled
    />

    <button
      type="button"
      className="btn btn-secondary"
      data-bs-toggle="modal"
      data-bs-target="#modalCatalogo"
    >
      Pesquisar
    </button>
  </div>

  {/* MODAL DE CATÁLOGOS */}
  <div
    className="modal fade mt-5"
    id="modalCatalogo"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    aria-labelledby="modalCatalogoLabel"
    aria-hidden="true"
  >
    <div className="modal-dialog modal-lg">
      <div className="modal-content">
        <div className="modal-header">
          <h1 className="modal-title fs-5" id="modalCatalogoLabel">
            Pesquisa Catálogo
          </h1>

          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          />
        </div>

        <div className="modal-body">

          {/* PESQUISA */}
          <div className="input-group mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Digite sua pesquisa"
              value={buscaCtWeb}
              onChange={(e) => setBuscaCtWeb(e.target.value)}
            />

            <button
              className="btn btn-primary"
              type="button"
             
            >
              <i className="fas fa-search"></i> Pesquisar
            </button>
          </div>

          {/* RESULTADOS */}
          <table className="table table-hover table-striped">
            <thead>
              <tr>
                <th>ID</th>
                <th>Descrição</th>
                <th>Ação</th>
              </tr>
            </thead>

            <tbody className="table-group-divider">
              {produtosCatalogo?.map((produto) => (
                <tr key={produto.id}>
                  <td>{produto.id}</td>
                  <td>{produto.nome}</td>
                  <td>
                    <a
                      href="#"
                      data-bs-dismiss="modal"
                      onClick={(e) => {
                        e.preventDefault();

                        setIdCatalogo(produto.id);

                        // caso queira guardar também a descrição
                        // setDescricaoCatalogo(catalogo.nome);
                      }}
                    >
                      <i className="bi bi-check2 icone-acao"></i>
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

        </div>
      </div>
    </div>
  </div>
</div>

                
                  <div className="col-2">
                    <label htmlFor="inputAddress" className="form-label">
                      FATOR
                    </label>
                    <NumericFormat
                      className="form-control"
                      id="inputMarkup"
                      value={deflator.toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })}
                      tabIndex="7"
                      allowLeadingZeros
                      decimalSeparator=","
                      thousandSeparator="."
                      decimalScale={3}
                      onValueChange={(values, suorceInfo) => {
                        setDeflator(values.value);
                      }}
                    />
                  </div>

                  <div className="col-2">
                    <label htmlFor="inputAddress" className="form-label">
                      PREÇO NO APP
                    </label>
                    <NumericFormat
                      className="form-control"
                      id="inputMarkup"
                      value={precoApp.toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })}
                      tabIndex="7"
                      allowLeadingZeros
                      decimalSeparator=","
                      thousandSeparator="."
                      onBlur={calculaVenda}
                      decimalScale={2}
                      prefix="R$ "
                      onValueChange={(values, suorceInfo) => {
                        setPrecoApp(values.value);
                      }}
                    />
                  </div>

                  
                </div>
              </div>{" "}
            </div>

            <div className="col-12 mb-5">
              <hr />
              <Link
                to="/app/produto"
                type="submit"
                className="btn btn-outline-primary butao"
                tabIndex="14"
              >
                Desistir
              </Link>
              {tag !== "0" ? (
                <button
                  type="submit"
                  onClick={salvaProduto}
                  className="btn btn-primary butao"
                  tabIndex="13"
                >
                  Salvar
                </button>
              ) : null}
            </div>

            {mensagem.length > 0 ? (
              <div className="alert alert-danger mt-2" role="alert">
                {mensagem}
              </div>
            ) : null}
            {sucesso === "S" ? <Navigate to="/app/produto" /> : null}
          </form>
        </div>
        {erroValidacao ? (
          <SweetAlert
            danger
            confirmBtnText="OK"
            confirmBtnBsStyle="danger"
            title="Erro"
            onConfirm={() => setErrovalidacao(false)}
          >
            {msgErro}
          </SweetAlert>
        ) : null}
        {showModal && (
  <div className="modal fade show d-block" tabIndex="-1">
    <div className="modal-dialog modal-lg">
      <div className="modal-content">

        <div className="modal-header">
          <h5 className="modal-title">Selecionar Produto</h5>
          <button
            className="btn-close"
            onClick={() => setShowModal(false)}
          ></button>
        </div>

        <div className="modal-body">

          {/* 🔍 Busca */}
          <div className="mb-3 d-flex gap-2">
            <input
              type="text"
              className="form-control"
              placeholder="Buscar produto..."
              value={busca}
              onChange={(e) => setBusca(e.target.value)}
            />

            <button
              className="btn btn-primary"
              onClick={filtraProdutos}
            >
              Buscar
            </button>
          </div>

          {/* 📋 Lista */}
          <table className="table table-hover">
            <thead>
              <tr>
                <th>Código</th>
                <th>Descrição</th>
                <th>Preço</th>
                <th>Estoque</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {produtos.length > 0 ? (
                produtos.map((prod, index) => (
                  <tr key={index}>
                    <td>{prod.COD_PRODUTO}</td>
                    <td>{prod.DESCRICAO}</td>
                    <td>R$ {Number(prod.VENDA).toFixed(2)}</td>
                    <td>{prod.ESTOQUE}</td>

                    <td>
                      <button
                        className="btn btn-success btn-sm"
                        onClick={() => {
                          const novo = {
                            BARRA: prod.COD_PRODUTO,
                            DESCRICAO: prod.DESCRICAO,
                            PRECO: Number(prod.VENDA),
                            QTD: 1
                          };

                          setCompostos((prev) => [...prev, novo]);
                          setShowModal(false);
                        }}
                      >
                        Selecionar
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center">
                    Nenhum produto encontrado
                  </td>
                </tr>
              )}
            </tbody>
          </table>

        </div>

      </div>
    </div>

    {/* backdrop */}
    {/* <div className="modal-backdrop fade show"></div> */}
  </div>
)}
      </div>
      <FooterBar />
    </div>
  );
}

export default NovoProduto;
